import { z } from "zod";

export const invitationPreviewResponseSchema = z.object({
	group_id: z.string(),
	group_name: z.string(),
	group_photo_url: z.string().nullable(),
	inviter_first_name: z.string().nullable(),
	inviter_last_name: z.string().nullable(),
	inviter_photo_url: z.string().nullable(),
	expires_at: z.coerce.date(),
});

export type InvitationPreviewResponse = z.infer<typeof invitationPreviewResponseSchema>;

export const INVITATION_PREVIEW_ERRORS = {
	NOT_FOUND: "invitation_not_found",
	EXPIRED: "invitation_expired",
	ALREADY_RESPONDED: "invitation_already_responded",
} as const;

export type InvitationPreviewError = (typeof INVITATION_PREVIEW_ERRORS)[keyof typeof INVITATION_PREVIEW_ERRORS];
